import { FC } from 'react';
import { Heading, SimpleGrid } from '@chakra-ui/react';
import { useConnection } from 'store/connection';
import { useModal } from 'store/modals';
import { ModalType } from 'components/modals/types';
import { MintModalProps } from 'components/modals/MintModal';
import { useConfig } from 'store/config';
import { useWeb3React } from 'hooks/web3';
import { convertChainIdToNativeTokenSymbol } from 'utils/convertChainIdToNetworkName';
import { useCustomMinterFee } from 'hooks/useCustomMinterFee';
import MintingCard from 'components/minting/MintingCard';

const Intro: FC = () => {
  const { openModal } = useModal();
  const { chainId = 1 } = useWeb3React();
  const { tried } = useConnection();
  const { mintingTokenAddress } = useConfig(chainId).config;
  const { fee } = useCustomMinterFee();

  return (
    <>
      {tried ? (
        <>
          <Heading size='xl' textAlign='center' py={8}>
            Mint a Crucible
          </Heading>
          <SimpleGrid
            columns={[1, null, 2, null, mintingTokenAddress ? 3 : 2]}
            spacing={[5, null, null, 10]}
            mx={[5, null, null, 10]}
          >
            <MintingCard
              type='basic'
              description='Create your smart wallet'
              benefits={[
                'Access all Reward Programs',
                'Can be upgraded to PRO'
              ]}
              requirement='NONE'
              onClick={() =>
                openModal(ModalType.mint, {
                  type: 'basic'
                } as MintModalProps)
              }
            />
            <MintingCard
              isPopular
              type='pro'
              description='Become a Crucible Key holder'
              benefits={[
                'Access all Reward Programs',
                'Unlock Crucible Artwork',
                'Crucible Key: Get access to exclusive benefits'
              ]}
              requirement={`${fee && fee} ${convertChainIdToNativeTokenSymbol(
                chainId
              )}`}
              onClick={() =>
                openModal(ModalType.mint, {
                  type: 'pro'
                } as MintModalProps)
              }
            />
            {mintingTokenAddress && (
              <MintingCard
                type='platinum'
                description='Get Crucible Key and start earning'
                benefits={[
                  'Access all Reward Programs',
                  'LP used is automatically subscribed to Aludel v1.5',
                  'Unlock Crucible Artwork',
                  'Crucible Key: Get access to exclusive benefits'
                ]}
                requirement='MIST - ETH LP'
                onClick={() =>
                  openModal(ModalType.mint, {
                    type: 'platinum'
                  } as MintModalProps)
                }
              />
            )}
          </SimpleGrid>
        </>
      ) : null}
    </>
  );
};

export default Intro;
